import Vue from 'vue'
import pwaService from "./service/pwaService";
import onesignalService from "./service/onesignalService";
import env from "env";

function renderPage() {
    if (global.page_inited) {
        return
    }

    //parse page
    Array.from(document.querySelectorAll("*[data-page]")).forEach((ele) => {
        const alias =  ele.getAttribute("data-page");

        import(
            /* webpackMode: "eager" */
            /* webpackInclude: /\.js$/ */
            /* webpackExclude: /(webpack)/ */
            `./page/${alias}.js`
            );

    });

    global.page_inited = true;
}

/**
 * render vue component
 */
const renderComponent = () => {
    const componentInited = global.componentInited || false;

    if (componentInited) {
        return
    }

    const elementList = document.querySelectorAll("*[data-component]");

    elementList.forEach((ele) => {
        const alias = ele.getAttribute("data-component"),
            props = JSON.parse(ele.innerText) || {};

        import(
            /* webpackMode: "eager" */
            /* webpackInclude: /\.vue/ */
            `./component/${alias}.vue`
            )
            .then((component) => {

                new Vue({
                    el: ele,
                    render: h => h(component.default || component, {props})
                });
            });

    });

    global["componentInited"] = true;
}

renderPage();
renderComponent();

export {
    renderPage,
    renderComponent,
}

if (!env.PWA_DISABLED) {
    pwaService.installServiceWorker();
    onesignalService.ready();
} else {
    pwaService.uninstallServiceWorker();
}
pwaService.addPWAInstaller();
